import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Components
import SVG from 'components/widgets/icons/svg';


export default class EmailDetails extends React.Component {
  static propTypes = {
    email: PropTypes.shape({
      setOpen: PropTypes.func,
      open: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool
      ])
    })
  }

  render() {
    const { email } = this.props;
    const open = email.open === 'emailDetails';
    const classes = classNames('triage-email-details', { 'triage-email-details-closed': !open });

    // If something is open but it isn't this hide everything
    if (!open && email.open) return null;

    return (
      <div onClick={() => email.setOpen(open ? false : 'emailDetails')} className={classes}>
        {open &&
          <div className="triage-option-form-header triage-option-header">
            <SVG src="svg/email.svg" className="email triage-option-icon" />
            <span>{email.subject}</span>
            <SVG src="svg/close.svg" className="close-triage-submenu" />
          </div>
        }
        <div dangerouslySetInnerHTML={{ __html: email.sanitizedHtmlShort }} className="triage-option-submenu" />
        { !open && <div className="triage-email-details-overlay" /> }
      </div>
    );
  }
}
